(() => {
  if (customElements.get('es-light-hero')) return;
  class LightHero extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.cleanup();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = [...this.querySelectorAll('[data-hero-slide]')];
        this.index = 0;
        this.visible = false;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.controls = this.querySelector('[data-hero-controls]');
        if (!this.controls || !this.slides.length) return;
        this.controls.hidden = false;
        this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.select(this.index - 1), options);
        this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.select(this.index + 1), options);
        this.reduced.addEventListener('change', () => this.sync(), options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.select(index);
        }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold: .05 });
        this.observer.observe(this.querySelector('.es-hero-slideshow') || this);
        this.select(0);
      });
    }
    select(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; slide.inert = i !== this.index; });
      const count = this.querySelector('[data-hero-count]');
      if (count) count.textContent = `${this.index + 1} / ${this.slides.length}`;
      this.sync();
    }
    sync() {
      const active = this.slides[this.index]?.querySelector('video');
      this.querySelectorAll('video').forEach(video => {
        if (video !== active || !this.visible || this.reduced.matches || navigator.connection?.saveData === true || document.hidden) { video.pause(); return; }
        if (!video.hasAttribute('src')) { video.src = video.dataset.src; video.load(); }
        video.muted = true;
        video.play().catch(() => {});
      });
    }
    cleanup() { this.controller?.abort(); this.observer?.disconnect(); this.querySelectorAll('video').forEach(video => video.pause()); }
    disconnectedCallback() { this.cleanup(); }
  }
  customElements.define('es-light-hero', LightHero);
})();
